import React from 'react';
import { ATMField, ATMForm, ATMSelect } from 'shared-it-appmod-ui';
import BlockEmployee from 'src/components/atoms/block-employee/block-employee.component';
import DropdownEmployee from 'src/components/atoms/dropdown/dropdown-employee/dropdown-employee.component';
import { AdminRoles } from 'src/constants';
import Lang from 'src/libraries/language';
import { AdminFormSchema } from 'src/models/admin.model';
import { IEmployee } from 'src/models/employee.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  employee?: IEmployee;
  defaultValues: any;
  disableField?: boolean;
  handleSubmit: (data) => void;
  handleSearch: (id) => void;
  handleEnable: (value) => void;
};

const RoleMaintenanceForm: React.FC<IProp> = ({
  formRef,
  employee,
  defaultValues = {},
  disableField = false,
  handleSubmit,
  handleSearch,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={AdminFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <>
              <ATMField
                label={Lang.LBL_EMPLOYEE_NAME}
                name="empNo"
                control={control}
                as={DropdownEmployee}
                placeholder={Lang.LBL_SEARCH}
                onChange={([_, { value }]) => {
                  handleSearch(value);

                  return value;
                }}
                icon="search"
                clearable
                required
                disabled={disableField}
                error={errors.empNo}
              />

              {employee && <BlockEmployee data={employee} />}

              <br />
              <ATMField
                label={Lang.LBL_EMPLOYEE_ROLE}
                name="roleId"
                control={control}
                as={ATMSelect}
                placeholder={Lang.LBL_SELECT}
                options={Object.values(AdminRoles).map((role) => ({
                  key: role.roleId,
                  text: role.name,
                  value: role.roleId,
                }))}
                onChange={([_, { value }]) => value}
                required
                error={errors.roleId}
              />
            </>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default RoleMaintenanceForm;
